export const FRAME_EVIDENCE_STALE_MS = 3_000;
export const VISIBLE_STALL_KEYFRAME_MS = 1_500;
export const VISIBLE_STALL_REFRESH_MS = 3_000;
export const HANDOFF_HEALTHY_HOLD_MS = 5_000;
export const HANDOFF_OBSERVATION_MAX_POLLS = 2;
export const POOR_PLAYBACK_WINDOW_MS = 10_000;
export const POOR_PLAYBACK_REQUIRED_MS = 6_000;
/** Presentation-only trouble must qualify before bitrate protection begins. */
export const POOR_PLAYBACK_BITRATE_HOLD_MS = 2_000;
export const CONTINUOUS_LOW_FPS_REQUIRED_MS = 2_000;
export const RESOLUTION_HOST_VERIFY_MS = 5_000;
export const RESOLUTION_RECEIVER_VERIFY_MS = 10_000;
export const RESOLUTION_RETRY_LIMIT = 1;
